import React from 'react';
import ProjectDetailView from 'components/ProjectDetailView/ProjectDetailView';
import fortressData from './data';

const Fortress = () => {
  return <ProjectDetailView data={fortressData} />;
};

export default Fortress;
